import React from 'react';
import { useAccount } from '@/hooks/useAccount';
import { TabNav } from '@repo/ui/Tabs';
import { NavTab } from '@repo/ui/Tabs';
import { useUser } from '@repo/hooks/useUser';
import { POLICIES } from '@/lib/Authorization';

const AccountSettingsTabNav = () => {
  const currentAccount = useAccount();
  const user = useUser();
  const isMasterAccount = currentAccount?.parentAccount === null;

  const SettingsTabs: (NavTab | null)[] = [
    {
      title: 'Overview',
      href: `/a/${currentAccount?.id}/account-settings`,
    },
    isMasterAccount && POLICIES['account_primary_contacts:index'](user)
      ? {
          title: 'Contacts',
          href: `/a/${currentAccount?.id}/account-settings/contacts`,
        }
      : null,
    !isMasterAccount && POLICIES['account_primary_contacts:index'](user)
      ? {
          title: 'Contact',
          href: `/a/${currentAccount?.id}/account-settings/contact`,
        }
      : null,
  ];

  return <TabNav tabs={SettingsTabs} />;
};

export default AccountSettingsTabNav;
